module.exports = __webpack_public_path__ + "static/media/equalicare-img09.6b06d759.png";